import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';
import { IBaseActionsInjectable } from '../../core/interface';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

export default class BaseActionsInjectable implements IBaseActionsInjectable {
    public get floatContentOffset() {
        // 从微盘打开 native 会在 html 中会注入高度为 32 的顶部条，从 (0, 0) 位置向上查找会失败
        const pointY = config.supportEnterprise(EnterPriseType.ALL) ? 40 : 0;
        return { x: 0, y: pointY };
    }

    public showComment(): boolean {
        return getCacConfigByKey('feature.comment', false);
    }
}
